import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, ArrowRight, Bot } from "lucide-react";
import { WHATSAPP_LINK } from "../data/site";
import ChatBot from "./ChatBot";

export default function StickyCTAs() {
  const [visible, setVisible] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.matchMedia("(min-width: 768px)").matches : true
  );

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    const mq = window.matchMedia("(min-width: 768px)");
    const onMq = () => setIsDesktop(mq.matches);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    mq.addEventListener("change", onMq);
    return () => {
      window.removeEventListener("scroll", onScroll);
      mq.removeEventListener("change", onMq);
    };
  }, []);

  function trackCTA(label) {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "cta_click", { location: "sticky_bar", label });
    }
  }

  return (
    <>
      <div
        data-testid="floating-ctas"
        className={`fixed left-3 right-3 md:left-1/2 md:right-auto md:-translate-x-1/2 md:w-auto z-40 transition-all duration-500 ${
          visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
        style={{ bottom: "max(12px, env(safe-area-inset-bottom, 12px))" }}
      >
        <div className="glass shadow-soft rounded-full p-1.5 flex items-stretch gap-1.5 md:min-w-[520px]">
          <Link
            to="/contact#lead-form"
            data-testid="floating-request-quote"
            onClick={() => trackCTA("request_a_quote")}
            className="group flex-1 inline-flex items-center justify-center gap-2 bg-[#1e2a5a] text-[#faf6ef] hover:bg-[#b4462a] rounded-full px-4 md:px-7 py-3.5 md:py-4 text-sm md:text-base font-bold tracking-wide transition-all"
          >
            <span>Request a Quote</span>
            <ArrowRight size={16} strokeWidth={2.2} className="group-hover:translate-x-1 transition" />
          </Link>

          {isDesktop ? (
            <button
              onClick={() => { setChatOpen((v) => !v); trackCTA("chat_with_us"); }}
              data-testid="floating-chatbot-toggle"
              className="flex-1 inline-flex items-center justify-center gap-2 bg-[#faf6ef] hover:bg-[#d98f2f] text-[#1e2a5a] hover:text-[#faf6ef] rounded-full px-4 md:px-7 py-3.5 md:py-4 text-sm md:text-base font-bold tracking-wide transition-all border border-[#1e2a5a]/10"
            >
              <Bot size={16} strokeWidth={2.2} />
              <span>{chatOpen ? "Close Chat" : "Chat with us"}</span>
            </button>
          ) : (
            <a
              href={WHATSAPP_LINK()}
              target="_blank"
              rel="noreferrer"
              data-testid="floating-whatsapp"
              onClick={() => trackCTA("whatsapp_mobile")}
              className="flex-1 inline-flex items-center justify-center gap-2 bg-[#faf6ef] hover:bg-[#d98f2f] text-[#1e2a5a] hover:text-[#faf6ef] rounded-full px-4 py-3.5 text-sm font-bold tracking-wide transition-all border border-[#1e2a5a]/10"
            >
              <MessageCircle size={16} strokeWidth={2.2} />
              <span>Chat on WhatsApp</span>
            </a>
          )}
        </div>
      </div>

      {isDesktop && <ChatBot open={chatOpen} onClose={() => setChatOpen(false)} />}
    </>
  );
}
